/* filter functionality (collection page) */
const filter = {
  init(){
    this.collection_filter_container = $(".collection-filter-container");
    this.mobile_filter_header_container = document.querySelector(".filter-left-container");
    this.collection_filter_wrapper = document.querySelector(".collection-filter-wrapper");
    this.entire_collection_container = document.querySelector(".entire-filter-section-container");
    this.mobile_cross = document.querySelector(".mobile-filter-cross");
    this.mobile_search_icon = document.querySelector(".mobile-filter-search");
    this.search_form = document.querySelector(".collection-search");
    this.addEventListeners();
    this.sortFilterListContent();
  },
  showFilterMenu(selector){
    let dropdown_container = selector.find(".filter-dropdown-container");
    let dropdown_list_element = dropdown_container.find("li");
    selector.find(".collection-filter-arrow").addClass("active");

    dropdown_container.addClass("active");
    dropdown_list_element.mouseenter(function(){
      $(this).addClass("active");
    });
    dropdown_list_element.mouseleave(function(){
      $(this).removeClass("active");
    });
  },
  hideFilterMenu(selector){
    selector.find(".filter-dropdown-container").removeClass("active");
    selector.find(".collection-filter-arrow").removeClass("active");
  },
  hideAllOtherFilterMenus(){
    $(".filter-dropdown-container").removeClass("active");
    $(".collection-filter-arrow").removeClass("active");
  },


  sortFilterListContent(){
    let collection_filter_container = document.querySelectorAll(".collection-filter-container");
    if(collection_filter_container !== null || collection_filter_container !== undefined){
      collection_filter_container.forEach((container) => {
        let list_elements = $(".collection-filter-container ul li");
        let text = container.querySelectorAll("ul li a");
        let used_array = [];
        let obj = {};
        /* remove duplicates */
        $(".collection-filter-container ul li").each(function(){
          //let text = $.trim($(this).text().replace(/ *\([^)]*\) */g, ""));
          let text = $.trim($(this).text());
          let text_collection = $(this).find(".filter_dropdown_product_title").text();
          let product_collection = $(this).find(".filter_dropdown_product_collection").text();
          if(text_collection == product_collection){
            $(this).find(".filter_dropdown_product_collection").remove();
            $(this).find(".filter_dropdown_dash").remove();
          }
          console.log(text_collection);
          if(obj[text]){
            $(this).remove();
          } else {
            obj[text] = true;
          }
        });
        for(let i = 0; i < list_elements.length; i++){  
          // let index = used_array.indexOf(list_elements[i].innerHTML);
          // console.log(index); 
          // if(index == -1){
          //   used_array.push(list_elements[i].innerHTML);
          // } else {
          //   list_elements[i].remove();
          // }
        }
        /* remove hyphens */
        text.forEach(a =>{
          if(a !== undefined || a !== null){
            a.innerHTML = a.innerHTML.split("-").join(" ");
          }
        });
        /* remove duplicate collection */
        /* remove dropdown if list elements do not exist */
        if(list_elements.length <= 0){
          container.style.display = "none";
          container.remove();
        }
      });
    }
  },


  openMobileMenu(){
    this.collection_filter_wrapper.classList.add("active");
    this.entire_collection_container.classList.add("active");
    this.mobile_cross.classList.add("active");
    this.search_form.classList.add("hide");
    this.collection_filter_container.show();
  },
  openMobileSearch(){
    this.collection_filter_wrapper.classList.add("active");
    this.entire_collection_container.classList.add("active");
    this.collection_filter_container.hide();
    this.mobile_cross.classList.add("active");
    this.search_form.classList.add("active");
  },
  closeMobileMenu(){
    this.collection_filter_wrapper.classList.remove("active");
    this.entire_collection_container.classList.remove("active");
    this.search_form.classList.remove("hide");
    this.mobile_cross.classList.remove("active");
    this.hideAllOtherFilterMenus();
  },
  addEventListeners(){
    if(this.mobile_filter_header_container != null || this.mobile_filter_header_container != undefined){
      this.mobile_filter_header_container.addEventListener("click", () => {
        this.openMobileMenu();
      });
    }
    if(this.mobile_cross != null || this.mobile_cross != undefined){
      this.mobile_cross.addEventListener("click", () => {
        this.closeMobileMenu();
      });
    }
    if(this.mobile_search_icon != null || this.mobile_search_icon != undefined){
      this.mobile_search_icon.addEventListener("click", () => {
        this.openMobileSearch();
      });
    }
    if(this.collection_filter_container != null || this.collection_filter_container != undefined){
      this.collection_filter_container.each(function(){
        $(this).click(function(){
          let filter_dropdown_container = $(this).find(".filter-dropdown-container");
          if(filter_dropdown_container.hasClass("active")){
            if($(window).width() < 798){
              filter.hideFilterMenu($(this));
            }
          } else {
            filter.hideAllOtherFilterMenus();
            filter.showFilterMenu($(this));
          }
        });
        if($(window).width() > 798){
          $(this).mouseleave(function(){  
            filter.hideFilterMenu($(this));
          });
        }
      });
    }
  }
}